import { User } from "../types/User";
import { api } from "./api/apiSlice";

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<User[], void>({
      query: () => "users/",
      providesTags: ["users"],
    }),
    // update eventApi.ts
    updateUser: builder.mutation<User, any>({
      query: (data) => ({
        url: `users/${data?.id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["users"],
    }),
    addUser: builder.mutation<User, any>({
      query: (data) => ({
        url: `users/`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["users"],
    }),
    getUserById: builder.query<User, undefined | string>({
      query: (id) => `users/${id}`,
    }),
    getUserByEmail: builder.query<User, undefined | string>({
      query: (email) => `users/email/${email}`,
    }),
  }),
});

export const {
  useAddUserMutation,
  useUpdateUserMutation,
  useGetUserByIdQuery,
  useGetUsersQuery,
  useGetUserByEmailQuery,
} = userApi;
